
const laoExportLoadPlanFilters = {

    cubicationIdList: { // Cubication ID
      type: "text",
      name: "cubication_id",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },
    customerCodeList: { // Customer Code
      type: "text",
      name: "customer_code",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },   
    destinationCountryList: { // Destination Country
      type: "text",
      name: "destination_country",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    }, 
    storageLocationList: { // Storage Location
      type: "text",
      name: "storage_location",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },   
    availabilityDateRange: { // Availability Date
      type: "date",
      name: "availability_date",
      shortName: 'Availability Date',
      data: null
    },
    materialNumList: { // Material Number
      type: "text",
      name: "sku",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },
    itemDescWithSeparator: { // Item Desc
      type: "text",
      name: "description",
      stringToArray: false,
      stringValue: true, // for chips UI 
      separator: /;/,
      data: null,
      region: 'lao',
      helperText: "helperTextWithSeparator"
    },   
    exportOrderNumList: { // PO/SO Export
      type: "text",
      name: "po_so_export",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },  
    loadDateRange: { // Load Date
      type: "date",
      name: "load_date",
      shortName: 'Load Date',
      data: null
    },   
    deliveryNumList: { // Delivery Number
      type: "text",
      name: "delivery_number",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },   
    loadNumList: { // Load Number
      type: "text",
      name: "load_number",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },   
    billingDocNumList: { // Invoice Number
      type: "text",
      name: "invoice_num",
      stringToArray: true,
      data: null,
      region: 'lao',
      helperText: "helperText"
    },   
  };
  
  export default laoExportLoadPlanFilters;